/**
 * Utility functions for normalizing patient names to ensure consistency
 * and avoid duplicates in the database.
 *
 * Rules:
 * - Patient name/code: Full UPPERCASE
 */

/**
 * Normalize patient name or code to full uppercase
 * Examples:
 * - "jean-claude martin" -> "JEAN-CLAUDE MARTIN"
 * - "CODE-123" -> "CODE-123"
 * - "patient 456" -> "PATIENT 456"
 */
export const normalizePatientNameCode = (nameCode) => {
    if (!nameCode || typeof nameCode !== 'string') {
        return '';
    }

    return nameCode
        .trim()
        .toUpperCase();
};

/**
 * Validate that patient name/code is provided and not empty
 * @param {string} nameCode
 * @returns {boolean} True if name/code is valid
 */
export const validatePatientNameCode = (nameCode) => {
    const normalized = normalizePatientNameCode(nameCode);
    return normalized.length > 0;
};

/**
 * Format patient name/code for display
 * @param {Object} order - Order object containing patient info
 * @returns {string} Formatted patient name/code
 */
export const formatPatientDisplay = (order) => {
    return order.patient_name_code || 'Non renseigné';
};
